/**
 * @generated SignedSource<<5efa015768e5a68d7dda4b838fed5546>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgUserEditScreenDeleteUserMutation$variables = {
  userId: string;
};
export type OrgUserEditScreenDeleteUserMutation$data = {
  readonly organisation: {
    readonly deleteUser: {
      readonly user: {
        readonly id: string;
      };
    } | null;
  };
};
export type OrgUserEditScreenDeleteUserMutation = {
  response: OrgUserEditScreenDeleteUserMutation$data;
  variables: OrgUserEditScreenDeleteUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "concreteType": "OrgUser",
        "kind": "LinkedField",
        "name": "deleteUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgUserEditScreenDeleteUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgUserEditScreenDeleteUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d72ce182fb2df24a110924607b2b5259",
    "id": null,
    "metadata": {},
    "name": "OrgUserEditScreenDeleteUserMutation",
    "operationKind": "mutation",
    "text": "mutation OrgUserEditScreenDeleteUserMutation(\n  $userId: String!\n) {\n  organisation {\n    deleteUser(userId: $userId) {\n      user {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2a0af754d814c614f7ac72d82361cfc";

export default node;
